import type { DeeplinkPreset } from '../interfaces/deeplinkCatalog'

export const CURATED_DEEPLINK_PRESETS: DeeplinkPreset[] = [
  // Productivity & Notes
  {
    id: 'curated-shortcuts',
    name: 'Apple Shortcuts',
    scheme_url: 'shortcuts://',
    category: 'Productivity & Notes',
    icon: '⚡',
    is_curated: true,
  },
  {
    id: 'curated-notion',
    name: 'Notion',
    scheme_url: 'notion://',
    category: 'Productivity & Notes',
    icon: '📝',
    is_curated: true,
  },
  {
    id: 'curated-obsidian',
    name: 'Obsidian',
    scheme_url: 'obsidian://',
    category: 'Productivity & Notes',
    icon: '📓',
    is_curated: true,
  },

  // Audio & Media
  {
    id: 'curated-spotify',
    name: 'Spotify',
    scheme_url: 'spotify://',
    category: 'Audio & Media',
    icon: '🎵',
    is_curated: true,
  },
  {
    id: 'curated-apple-music',
    name: 'Apple Music',
    scheme_url: 'music://',
    category: 'Audio & Media',
    icon: '🎶',
    is_curated: true,
  },

  // Reading
  {
    id: 'curated-apple-books',
    name: 'Apple Books',
    scheme_url: 'ibooks://',
    category: 'Reading',
    icon: '📖',
    is_curated: true,
  },

  // Learning
  {
    id: 'curated-duolingo',
    name: 'Duolingo',
    scheme_url: 'duolingo://',
    category: 'Learning',
    icon: '🦉',
    is_curated: true,
  },
  {
    id: 'curated-anki',
    name: 'Anki',
    scheme_url: 'anki://',
    category: 'Learning',
    icon: '🗂️',
    is_curated: true,
  },
]
